import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Add, Minus } from '@factorialco/f0-react/icons/app'

interface Props {
  childrenCount: number
  isExpanded: boolean
}

const CollapsibleButton = ({ childrenCount, isExpanded }: Props) => {
  if (childrenCount === 0) {
    return null
  }

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      paddingX="s8"
      paddingY="s2"
      gap="s4"
      background={!isExpanded ? 'grey400' : 'grey000White'}
      borderRadius={{ all: 'abs012' }}
      border={{ all: { color: 'grey300', style: 'solid', width: 's1' } }}
      style={{ cursor: 'pointer', position: 'relative', top: '35px' }}
    >
      <Text color="grey800" size="100" weight="bold">
        {childrenCount}
      </Text>
      <Box
        background={isExpanded ? 'grey400' : 'grey600'}
        borderRadius={{
          all: 'abs100',
        }}
        padding="s2"
      >
        {isExpanded ? (
          <F0Icon icon={Minus} size="xs" className="text-f1-icon" />
        ) : (
          <F0Icon icon={Add} size="xs" className="text-f1-icon-inverse" />
        )}
      </Box>
    </Box>
  )
}

export default CollapsibleButton
